// extracted by mini-css-extract-plugin
export var formContainer = "_lq-0";
export var message = "_lq-1";